import { GenplanLayer } from "../../map/genplanLayer"
import { IGenericPlanContext } from "../types"
import { calcFieldTotal } from "./utils"

import m = omnia.models
import GenericPlanUnitId = omnia.models.GenericPlanUnitId
import { IGenericPlan, labels } from "../../omnia"

export class GenericPlanContext implements IGenericPlanContext {

    readonly id: number
    name: string
    productName: string
    private _units: GenericPlanUnitId

    private _unitsText: string
    private _unitsTextNoArea: string

    private _planTotal: number = 0
    private _fieldTotal: number = 0
    private _initFieldTotal

    private _labels: { [value: string]: string } = {}

    constructor(readonly plan: Partial<IGenericPlan>, private readonly layer: GenplanLayer) {

        this.id = plan
            ? plan.GenericPlanId
            : undefined

        if (this.id) {
            this.name = plan.Name
            this.productName = plan.ProductName
            this.units = plan.Units
            this._planTotal = plan.TotalQty || 0
            this._fieldTotal = calcFieldTotal(layer, plan.Units)
            this._labels = { ...(plan.Labels || {}) }
        }

        this._initFieldTotal = this._fieldTotal

        this.updateTotals()

    }

    get units() {
        return this._units
    }

    set units(value) {

        this._units = value
        this._unitsText = labels.GenericPlanUnitId(this.units) || ""
        this._unitsTextNoArea = this._unitsText.split("/")[0]

        if (this.layer) {
            this.layer.setUnits(value)
            this.layer.refresh()
        }

    }

    get unitsText() {
        return this._unitsText
    }

    get unitsTextNoArea() {
        return this._unitsTextNoArea
    }

    get planTotal() {
        return this._planTotal
    }

    get fieldTotal() {
        return this._fieldTotal
    }

    updateTotals() {
        this._fieldTotal = calcFieldTotal(this.layer, this.units)
        const diff = this._fieldTotal - (this._initFieldTotal || 0)
        this._planTotal = (this.plan.TotalQty || 0) + diff
    }

    isValid(): boolean {
        return (!!this.name) && (!!this.productName) && (!!this.units)
    }

    getLabels() {
        return { ...this._labels }
    }

    getLabel(value: string) {
        return this._labels[value]
    }

    setLabel(value: string, label: string) {
        this._labels[value] = label
    }

}
